import WowPrice from "@/client/components/wow_price/WowPrice";
import "./itemPage.css";

const makeUpdateTimeString = (timestampMs: number): string => {
    const timeAgoSecs = (Date.now() - timestampMs) / 1000;

    if (timeAgoSecs > 48 * 3600) return new Date(timestampMs).toLocaleString();

    const seconds = Math.floor(timeAgoSecs) % 60;
    const secondsStr = seconds + (seconds > 1 ? " seconds" : " second");
    if (timeAgoSecs < 60) return `${secondsStr} ago`;

    const minutes = Math.floor(timeAgoSecs / 60) % 60;
    const minutesStr = minutes + (minutes > 1 ? " minutes" : " minute");
    if (timeAgoSecs < 3600) return `${minutesStr} ago`;

    const hours = Math.floor(timeAgoSecs / 3600);
    const hoursStr = hours + (hours > 1 ? " hours" : " hour");
    return `${hoursStr} ${minutesStr} ago`;
};

const ItemCurrent = ({ data }: { data?: ApiAuctionItemData }): JSX.Element => {
    return (
        <div className="itemPageCurrentData">
            {data ? (
                <table>
                    <tbody>
                        <tr>
                            <th>Last Update</th>
                            <td title={new Date(data.timestamp).toLocaleString()}>{makeUpdateTimeString(data.timestamp)}</td>
                        </tr>
                        <tr>
                            <th>Min. Buyout</th>
                            <td>
                                <WowPrice value={data.minBuyout}></WowPrice>
                            </td>
                        </tr>
                        <tr>
                            <th>Market Value</th>
                            <td>
                                <WowPrice value={data.marketValue}></WowPrice>
                            </td>
                        </tr>
                        <tr>
                            <th>Auctions</th>
                            <td>{data.numAuctions}</td>
                        </tr>
                        <tr>
                            <th>Quantity</th>
                            <td>{data.quantity}</td>
                        </tr>
                    </tbody>
                </table>
            ) : (
                <>No data!</>
            )}
        </div>
    );
};

export default ItemCurrent;
